import OapFlowplayer from './code/Scripts/components/OapFlowplayer';

export default {
  components: {
    OapFlowplayer,
  },
};
